// extracted by mini-css-extract-plugin
module.exports = {"PageHeader":"StoreProfilePage_PageHeader__2OQeo"};